import type { IconTypes } from '@deriv/quill-icons';
import {
    TradeTypesUpsAndDownsRiseIcon,
    TradeTypesUpsAndDownsFallIcon,
    TradeTypesHighsAndLowsHigherIcon,
    TradeTypesHighsAndLowsLowerIcon,
    TradeTypesInsAndOutsEndsOutIcon,
    TradeTypesInsAndOutsEndsInIcon,
    TradeTypesInsAndOutsStaysInIcon,
    TradeTypesInsAndOutsGoesOutIcon,
    TradeTypesDigitsMatchesIcon,
    TradeTypesDigitsDiffersIcon,
    TradeTypesDigitsEvenIcon,
    TradeTypesDigitsOddIcon,
    TradeTypesDigitsOverIcon,
    TradeTypesDigitsUnderIcon,
    TradeTypesHighsAndLowsTouchIcon,
    TradeTypesHighsAndLowsNoTouchIcon,
    TradeTypesUpsAndDownsAsianUpIcon,
    TradeTypesUpsAndDownsAsianDownIcon,
    TradeTypesLookbacksCloseLowIcon,
    TradeTypesLookbacksHighCloseIcon,
    TradeTypesLookbacksHighLowIcon,
    TradeTypesUpsAndDownsOnlyUpsIcon,
    TradeTypesUpsAndDownsOnlyDownsIcon,
    TradeTypesUpsAndDownsResetUpIcon,
    TradeTypesUpsAndDownsResetDownIcon,
    TradeTypesHighsAndLowsHighIcon,
    TradeTypesHighsAndLowsLowIcon,
    TradeTypesSpreadsCallIcon,
    TradeTypesSpreadsPutIcon,
    TradeTypesMultipliersUpIcon,
    TradeTypesMultipliersDownIcon,
    TradeTypesAccumulatorStayInIcon,
    TradeTypesTurboLongIcon,
    TradeTypesTurboShortIcon,
    TradeTypesVanillaCallIcon,
    TradeTypesVanillaPutIcon,
    LabelPairedQuestionCaptionBoldIcon,
} from '@deriv/quill-icons';

export const tradeTypeIcons: {
    [key: string]: IconTypes;
} = {
    IcTradetypeCall: TradeTypesUpsAndDownsRiseIcon,
    IcTradetypePut: TradeTypesUpsAndDownsFallIcon,
    IcTradetypeCallBarrier: TradeTypesHighsAndLowsHigherIcon,
    IcTradetypePutBarrier: TradeTypesHighsAndLowsLowerIcon,
    IcTradetypeExpirymiss: TradeTypesInsAndOutsEndsOutIcon,
    IcTradetypeExpiryrange: TradeTypesInsAndOutsEndsInIcon,
    IcTradetypeRange: TradeTypesInsAndOutsStaysInIcon,
    IcTradetypeUpordown: TradeTypesInsAndOutsGoesOutIcon,
    IcTradetypeDigitmatch: TradeTypesDigitsMatchesIcon,
    IcTradetypeDigitdiff: TradeTypesDigitsDiffersIcon,
    IcTradetypeDigiteven: TradeTypesDigitsEvenIcon,
    IcTradetypeDigitodd: TradeTypesDigitsOddIcon,
    IcTradetypeDigitover: TradeTypesDigitsOverIcon,
    IcTradetypeDigitunder: TradeTypesDigitsUnderIcon,
    IcTradetypeOnetouch: TradeTypesHighsAndLowsTouchIcon,
    IcTradetypeNotouch: TradeTypesHighsAndLowsNoTouchIcon,
    IcTradetypeAsianu: TradeTypesUpsAndDownsAsianUpIcon,
    IcTradetypeAsiand: TradeTypesUpsAndDownsAsianDownIcon,
    IcTradetypeLbcall: TradeTypesLookbacksCloseLowIcon,
    IcTradetypeLbput: TradeTypesLookbacksHighCloseIcon,
    IcTradetypeLbhighlow: TradeTypesLookbacksHighLowIcon,
    IcTradetypeRunhigh: TradeTypesUpsAndDownsOnlyUpsIcon,
    IcTradetypeRunlow: TradeTypesUpsAndDownsOnlyDownsIcon,
    IcTradetypeResetcall: TradeTypesUpsAndDownsResetUpIcon,
    IcTradetypeResetput: TradeTypesUpsAndDownsResetDownIcon,
    IcTradetypeTickhigh: TradeTypesHighsAndLowsHighIcon,
    IcTradetypeTicklow: TradeTypesHighsAndLowsLowIcon,
    IcTradetypeCallspread: TradeTypesSpreadsCallIcon,
    IcTradetypePutspread: TradeTypesSpreadsPutIcon,
    IcTradetypeMultup: TradeTypesMultipliersUpIcon,
    IcTradetypeMultdown: TradeTypesMultipliersDownIcon,
    IcTradetypeAccu: TradeTypesAccumulatorStayInIcon,
    IcTradetypeTurboslong: TradeTypesTurboLongIcon,
    IcTradetypeTurbosshort: TradeTypesTurboShortIcon,
    IcTradetypeVanillaLongCall: TradeTypesVanillaCallIcon,
    IcTradetypeVanillaLongPut: TradeTypesVanillaPutIcon,
    IcUnknown: LabelPairedQuestionCaptionBoldIcon,
} as const;
